import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class SpotlightService {
  constructor(private base: BaseService) {}

  save(data) {
    return this.base.post("/api/spotlights-create", data);
  }

  updateSpotlight(data) {
    return this.base.post("/api/spotlights-update", data);
  }

  editSpotlight(id) {
    return this.base.post("/api/spotlights-edit",  { id: id });
  }


  deleteSpotlight(id) {
    return this.base.post("/api/spotlights-delete", { id: id });
  }





}
